import { useMutation } from '@apollo/client';
import useNotifier from 'hooks/useNotifier';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { handleGQLErrors } from 'utils/gqlErrors';
import AddItem from '../components/AddItem';
import { defaultOrganization, itemRoutes } from '../constants';
import { OrganizationContext } from '../context/OrganisationProvider';
import {
  CreateOrganization,
  CreateOrganizationVariables,
} from '../types/CreateOrganization';
import { createOrganizationMutation } from '../mutations';
import clientClientService from '../../utils/clientClientService';
import { UpdateOrganizationInput } from '../../types/clientServiceGlobalTypes';

const AddItemContainer = () => {
  const notify = useNotifier();
  const history = useNavigate();
  const { getItems } = React.useContext(OrganizationContext);

  const [createItem, createItemOpts] = useMutation<
    CreateOrganization,
    CreateOrganizationVariables
  >(createOrganizationMutation, {
    client: clientClientService,
    onCompleted: async (data) => {
      notify({
        status: 'success',
        text: 'Created successfully.',
      });
      getItems();
      history(itemRoutes.list);
    },
    onError: (err) => {
      handleGQLErrors(notify, err);
    },
  });

  const handleSubmit = (input: UpdateOrganizationInput) => {
    const address = input.orgAddress;
    createItem({
      variables: {
        createOrganizationInput: {
          contactRole: input.contactRole || '',
          orgAddress: {
            // ...address,
            city: address?.city || '',
            country: address?.country || '',
            postcode: address?.postcode || '',
            srpc: address?.srpc || '',
            street: address?.street || '',
            unit: address?.unit || '',
            locationAddressDto: {
              inputAddressLatitude: address?.UpdateLocationAddressDto?.lat || 0,
              inputAddressLongitude:
                address?.UpdateLocationAddressDto?.lng || 0,
            },
          },
          orgDescription: input.orgDescription || '',
          orgName: input.orgName,
          orgProfile: input.orgProfile || '',
        },
      },
    });
  };

  return (
    <AddItem
      handleSubmit={handleSubmit}
      item={defaultOrganization}
      isLoading={createItemOpts.loading}
    />
  );
};

export default AddItemContainer;
